import { useTranslation } from 'react-i18next';

import { Wrapper, EmojiWrapper, Title, Description, TextWrapper } from '../EmptyMessages.styles';

export const RestDay: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  return (
    <Wrapper>
      <EmojiWrapper>
        <span role="img" aria-label="dance-man">
          🕺
        </span>
      </EmojiWrapper>
      <TextWrapper>
        <Title>{t('REST_DAY_TITLE')}</Title>
        <Description>{t('REST_DAY_DESCRIPTION')}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
